import { Column } from 'app/design/primitives/box';
import { Page } from 'app/design/primitives/page';
import { Placeholder, PlaceholderLine, ShineOverlay } from 'app/overrides/rn-placeholder';
import { createTheme as createDSTheme } from 'app/shopify';
import { HeaderSection } from './components/header-section';
import { MemberRowSkeleton } from './member-row-skeleton';

const theme = createDSTheme();

export function GroupedListingSkeleton() {
  return (
    <Page>
      <Column gap="spacing.general.x8">
        <HeaderSection.Skeleton />

        <Placeholder Animation={ShineOverlay}>
          <PlaceholderLine
            style={{
              height: 20,
              width: 160,
              borderRadius: theme.borderRadii['radius.lg'],
              marginBottom: theme.spacing['spacing.general.x2'],
            }}
          />

          {Array.from({ length: 3 }, (_, index) => (
            <MemberRowSkeleton key={index} />
          ))}
        </Placeholder>
      </Column>
    </Page>
  );
}
